<!-- eslint-disable vue/no-v-html -->
<template>
	<MainContainer
		header-selected="about-us"
		:loading="pending"
		:fetched="content !== undefined"
		:error="error"
		no-company-branding
		@try-again="refresh"
	>
		<div class="flex w-full flex-col px-4 pb-24 pt-16 lg:px-6">
			<div class="flex w-full max-w-screen-xl flex-col self-center">
				<div class="flex items-center">
					<span class="text-natural-dark flex-grow text-3xl font-black">
						{{ $t("about_us") }}
					</span>
				</div>
				<div class="mt-16 flex flex-col">
					<div class="flex flex-col" v-html="content || $t('edit_this_text_from_the_admin_panel')"></div>
				</div>
			</div>
		</div>
	</MainContainer>
</template>

<script lang="ts" setup>
const metaStore = useMetaStore()
const route = useRoute()

const {
	data: content,
	refresh,
	error,
	pending
} = useLazyAsyncData(String(route.path), () =>
	metaStore.getMeta({
		name: META_KEYS.META_ABOUT_US
	})
)
</script>
